var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-setting',{attrs:{"changeEmailRequestIsDone":_vm.changeEmailRequestIsDone,"loginUserInfo":_vm.userInfo},on:{"changePassword":_vm.handleOnChangePassword,"changeEmail":_vm.handleChangeEmail,"verifyEmail":_vm.handleVerifyEmail}})}
var staticRenderFns = []

export { render, staticRenderFns }